import { supabase } from '../supabase/client';
import { API_CONFIG, getApiUrl } from '../config';

/**
 * Submit a bug report to the API
 * @param {Object} reportData - Bug report data 
 * @param {string} reportData.description - Description of the bug
 * @param {string} reportData.steps - Steps to reproduce the bug (optional)
 * @returns {Promise<Object>} The API response
 */
export const submitBugReport = async (reportData) => {
  try {
    // Get the user's auth token
    const { data: authData } = await supabase.auth.getSession();
    const token = authData?.session?.access_token;
    
    if (!token) {
      throw new Error('No authentication token available');
    }
    
    // Format payload according to server requirements
    const formattedData = {
      title: "Bug Report", // Default title
      description: reportData.description,
      steps: reportData.steps || "",
      deviceInfo: navigator.userAgent,
      screenshot: "" // No screenshot functionality yet
    };
    
    // Call the API endpoint
    const response = await fetch(
      getApiUrl(API_CONFIG.POKKETAPI.ENDPOINTS.SUBMIT_BUG_REPORT),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formattedData)
      }
    );
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to submit bug report: ${response.status} ${response.statusText} - ${errorText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error submitting bug report:', error);
    throw error;
  }
}; 